import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { DataPackLine } from '../../app/models/dataPackLine.model';

import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';

import { GlobalVariable } from 'app/app.global';
import { DataPackGroup } from 'app/models/start';
/**
 * @version $Id: packages.service.ts 91275 2018-05-15 20:41:25Z eduardo.s.neto $
 */
@Injectable()
export class PackagesService extends CommonService  {

  private localURL: string;
  private PACKAGES_PATH: string = '/datapackpackages';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.PACKAGES_PATH;
    this.baseURL = GlobalVariable.BASE_URL_API + '/datapackpackages';
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json; charset=UTF-8');
    headers.append('Accept', 'application/json');
    headers.append("Cache-Control", "no-cache");
    headers.append("Pragma", "no-cache");
    this.requestOptions = new RequestOptions({
      headers: headers
    });
  }


  public save(data: string) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }
  public loadView(startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=loadView';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }
  public loadViewHiring(startRow: number, fetchSize: number) {
    let url = this.baseURL + '?action=loadViewHiring';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.http.get(url, this.requestOptions));
  }



  public listGroupsHiring(startRow: number, fetchSize: number) {
    let url = this.baseURL + '?action=listGroupsHiring';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.http.get(url, this.requestOptions));
  }

  public listLinesHiring(group: DataPackGroup, startRow: number, fetchSize: number) {
    let url = this.baseURL + '?action=listLinesHiring'
    if(group) {
      url += '&groupId=' + group.id;
    }
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.http.get(url, this.requestOptions));;
  }

  public getServiceAcceptTerm() {
    let url = this.baseURL + '?action=getSvAcceptTerm'
    return this.convertResponse(this.http.get(url, this.requestOptions));;
  }

  public getAcceptTermHTML() {
    let a = document.createElement("a");
    a.href = this.localURL + '?action=getAcceptTermHTML';
    a.click();
  }

  public loadViewHiringNow(serviceType: string, startRow: number, fetchSize: number) {

      //console.log('Propertie ServiceType: ' + serviceType);
      let url = this.baseURL + '?action=loadViewHiring';
      if (startRow >= 0) {
          url += '&filter=' + serviceType;
      }
      if (startRow >= 0) {
          url += '&startRow=' + startRow;
      }
      if (fetchSize >= 0) {
          url += '&fetchSize=' + fetchSize;
      }
      return this.convertResponse(this.http.get(url, this.requestOptions));

  }
  public listLinesHiringNow(group: DataPackGroup, serviceType: string, startRow: number, fetchSize: number) {
      let url = this.baseURL + '?action=listLinesHiring';
      //console.log('Propertie ServiceType: ' + serviceType);

      if (startRow >= 0) {
          url += '&filter=' + serviceType;
      }
      if (group) {
          url += '&groupId=' + group.id;
      }
      if (startRow >= 0) {
          url += '&startRow=' + startRow;
      }
      if (fetchSize >= 0) {
          url += '&fetchSize=' + fetchSize;
      }
      return this.convertResponse(this.http.get(url, this.requestOptions));;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/packages.service.ts